/* global globalThis */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { FaUsers, FaBuilding, FaCog } from "react-icons/fa";
import PropTypes from "prop-types";

// Helper function to get flex direction class
const getFlexDirectionClass = (isOpen) => {
  return isOpen === false ? "flex-col" : "flex-row";
};

// Helper function to check if path is active
const isPathActive = (location, paths) => {
  if (Array.isArray(paths)) {
    return paths.some((path) => location.pathname.includes(path));
  }
  return location.pathname === paths || location.pathname.includes(paths);
};

// Menu item component to reduce cognitive complexity
const MenuItem = ({ isOpen, location, path, paths, title, icon, label, joyrideClass }) => {
  const flexClass = getFlexDirectionClass(isOpen);
  const activeClass = isPathActive(location, paths) ? "active" : "";

  return (
    <li className={activeClass}>
      <Link
        className={`flex ${flexClass} ${joyrideClass}`}
        to={path}
        title={title}
      >
        {icon}
        <div className="sidebar-label">{label}</div>
      </Link>
    </li>
  );
};

MenuItem.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
  paths: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  joyrideClass: PropTypes.string.isRequired,
};

const Sidebar = ({ isOpen }) => {
  const location = useLocation();

  const getPermissions = () => JSON.parse(sessionStorage.getItem("rolesAndPermission") || "{}");
  const [permissions, setPermissions] = React.useState(getPermissions());

  React.useEffect(() => {
    const handlePermUpdate = () => setPermissions(getPermissions());
    globalThis.addEventListener("permissionsUpdated", handlePermUpdate);
    return () => globalThis.removeEventListener("permissionsUpdated", handlePermUpdate);
  }, []);

  const { UserMgmt, ObjectConfig, Administration } = permissions;

  if (isOpen !== false) {
    return null;
  }

  return (
    <div className="sidebar closed">
      <ul className={`sidebar-menu ${isOpen === false ? "margin-closed" : ""}`}>
         {ObjectConfig?.canView && (
          <MenuItem
            isOpen={isOpen}
            location={location}
            path="/organization-management"
            paths="/organization-management"
            title="Organization Management"
            icon={<FaBuilding className="menu-icon" />}
            label="Organization Management"
            joyrideClass="sidebar-orgmgmt-joyride-class"
          />
        )}
        {UserMgmt?.canView && (
          <MenuItem
            isOpen={isOpen}
            location={location}
            path="/user-management"
            paths="/user-management"
            title="User Management"
            icon={<FaUsers className="menu-icon" />}
            label="User Management"
            joyrideClass="sidebar-usermgmt-joyride-class"
          />
        )}
       
        {Administration?.canView && (
          <MenuItem
            isOpen={isOpen}
            location={location}
            path="/process-settings"
            paths="/process-settings"
            title="Process Settings"
            icon={<FaCog className="menu-icon" />}
            label="Process Settings"
            joyrideClass="sidebar-processsettings-joyride-class"
          />
        )}
      </ul>
    </div>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default Sidebar;
